import React from 'react';
import { motion } from 'framer-motion';
import Container from '../../../components/ui/Container';
import AnimatedCounter from '../../../components/ui/AnimatedCounter';
import ScrollReveal from '../../../components/ui/ScrollReveal';

const stats = [
  { value: 2000, suffix: '+', label: 'Students Trained' },
  { value: 10, suffix: '+', label: 'Programs' },
  { value: 10, suffix: '+', label: 'Countries' },
  { value: 100, suffix: '%', label: 'Success Rate' },
];

const StatsSection = () => {
  return (
    <section className="relative py-12 md:py-16 overflow-hidden">
      <div className="absolute inset-0 mesh-gradient" />

      {/* Floating gradient orbs */}
      <div className="absolute top-1/4 left-[10%] w-40 h-40 bg-brand-400/10 rounded-full blur-3xl animate-float" />
      <div className="absolute bottom-1/4 right-[15%] w-56 h-56 bg-brand-500/10 rounded-full blur-3xl animate-float" style={{ animationDelay: '1s' }} />
      <div className="absolute top-1/2 left-1/2 w-32 h-32 bg-brand-600/10 rounded-full blur-3xl animate-float" style={{ animationDelay: '2s' }} />

      <div className="section-divider-brand absolute top-0 left-0 right-0" />

      <Container className="relative z-10">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8 text-center">
          {stats.map((stat, i) => (
            <ScrollReveal key={i} animation="fade-up" delay={i * 0.1}>
              <motion.div
                initial={{ opacity: 0, y: 20, scale: 0.9 }}
                whileInView={{ opacity: 1, y: 0, scale: 1 }}
                viewport={{ once: true }}
                transition={{
                  type: 'spring',
                  stiffness: 100,
                  damping: 12,
                  delay: i * 0.15,
                }}
              >
                <div className="text-3xl sm:text-4xl md:text-5xl font-heading font-bold text-[var(--color-text-brand)]">
                  <AnimatedCounter end={stat.value} suffix={stat.suffix} />
                </div>
                <p className="mt-2 text-sm font-medium text-[var(--color-text-secondary)]">
                  {stat.label}
                </p>
              </motion.div>
            </ScrollReveal>
          ))}
        </div>
      </Container>

      <div className="section-divider-brand absolute bottom-0 left-0 right-0" />
    </section>
  );
};

export default StatsSection;
